import {some} from 'lodash'
export default function anyBadBleed(bleedPoints){
  const outerPoints = [].concat(...bleedPoints.map(bleedPoint => bleedPoint.o));
  return _.some(outerPoints, point => point.badBleed );
}



// WEBPACK FOOTER //
// ./src/lib/anyBadBleed.js